import { Component } from '@angular/core';
import { AppConfigService } from './services/app-config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { IomService } from './services/iom.service';
import { AutoLogoutService } from './services/autologout.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType,AuthenticationResult } from '@azure/msal-browser';
import { SessionService } from './services/session.service';
declare var userNotification: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'IOMAngular';
  public envData: any = null;
  public param: any;
  public decodeenterprise: string = "";
  message: string = "";
  subscription: Subscription;
  urlVersionId: string;
  LoggedInUser: string;
  bookmarkversionId: boolean = false;

  failureSubscription: Subscription;
  successSubscription: Subscription;
  enterpriseId: string;
  isIframe: boolean = false;
  subscriptions: Subscription[] = [];

  constructor(public route: ActivatedRoute, private appConfigService: AppConfigService, private broadcastService: MsalBroadcastService, private msalService: MsalService,
    public iomservice: IomService, private service: AutoLogoutService,
    public spinner: NgxSpinnerService, private router: Router, private sessionService: SessionService) {
    this.envData = this.appConfigService.getEnvironment();
    if (this.envData.instanceType != 'FDS') {
      this.initInterval();
    }
    //  This is to avoid reload during acquireTokenSilent() because of hidden iframe
    this.isIframe = window !== window.parent && !window.opener;
    if (!!this.msalService.instance.getActiveAccount()) {
      let accnt = this.msalService.instance.getActiveAccount();
      this.enterpriseId = accnt?.username.split('@')[0];
      sessionStorage.setItem('userName', this.enterpriseId);

      // this.enterpriseId = this.msalService.instance.getActiveAccount().userName.split('@')[0];
      // sessionStorage.setItem('userName', this.enterpriseId);
    }   
  }

  ngOnInit() { 
    let loggedUserName: string = this.sessionService.getUserName();    
    if(loggedUserName==null && !window.location.href.includes('#code')){
      sessionStorage.setItem('redirectURL', window.location.href);
    }
    if(this.envData.mslConfig.enableMSAL == true){
      if(!this.isLoggedIn()) {
      console.log('************ user not logged in .. enter login details ******');
       this.msalService.loginRedirect();       
       this.msalService.instance.handleRedirectPromise().then(res => {
      if (res != null && res.account != null) {
      console.log("Entered handle redirect promise",res.account);
      this.msalService.instance.setActiveAccount(res.account);
      console.log('******************* acquire token call in promise ****************************');
      // this.acquireToken();
      this.enterpriseId = res.account.username.split('@')[0];
      sessionStorage.setItem('userName', this.enterpriseId);
      // this.clientName = res.account.name;
      console.log('userName ' + this.enterpriseId);
      var currentDateTime = new Date();
      currentDateTime.setMinutes(currentDateTime.getMinutes() + 60);
      document.cookie = "expires=" + currentDateTime.toUTCString() + ";secure;SameSite=Strict;";
      // this.bookmarkversionId = true;
      this.message = 'Loaded';
      console.log("***message ",this.message);
      window.location.reload();
      // console.log('user '+ this.clientName);
      // this._ss.setEnterpriseID(this.enterpriseId);
      // this.showLoader = false;
      // .userName.split('@')[0];
      }
      })
      } 
      else {
      // this.showLoader = false;
      console.log('************ user is logged in already *****');
      let accnt = this.msalService.instance.getActiveAccount();
      // this.bookmarkversionId = true;
      this.message = 'Loaded';
      console.log("****message***",this.message)
      console.log(accnt?.username);
      // this._ss.setEnterpriseID(accnt?.username);      

      if (sessionStorage.getItem('redirectURL') != null && sessionStorage.getItem('redirectURL') != '' && sessionStorage.getItem('redirectURL') != undefined && sessionStorage.getItem('redirectURL').toLowerCase().includes('e2euid')) {
        let x = sessionStorage.getItem('redirectURL')
        // localStorage.removeItem('ReturnURL');
        var params = {};
        var parser = document.createElement('a');
        parser.href = x;
        var vars = parser.search.substring(1).split('&');
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split('=');
          params[pair[0]] = decodeURIComponent(pair[1]);
      }
      console.log("params  -- ",params)
      if (x.includes('editproposal')) {
        if(params["E2EUID"]!=null){
        this.sessionService.setE2EUId(params["E2EUID"]);
        }
        else{
        this.sessionService.setE2EUId(params["E2EUId"]);
        }
        this.router.navigate(['editproposal'], { queryParams: { E2EUID: params["E2EUID"], username: params["username"] } });
      }
      else {
        if(params["E2EUID"]!=null){
        this.sessionService.setE2EUId(params["E2EUID"]);
        }
        else{
        this.sessionService.setE2EUId(params["E2EUId"]);
        }
        if(params["WSUID"]!=null && params["WSUID"]!=""){
          this.sessionService.setWSUId(params["WSUID"]);
          }
          else if(params["WSUId"]!=null && params["WSUId"]!=""){
          this.sessionService.setWSUId(params["WSUId"]);
          }
        sessionStorage.setItem("Instance", params["Instance"]);
        if(this.envData.Env == "SAAS_ManualUpload" && params["Instance"] == undefined){         
          sessionStorage.setItem("Instance", 'SAAS');
        }
        if(params["WSUID"]!=null && params["WSUID"]!=""){
          this.router.navigate(['deepdive'], { queryParams: { E2EUId: params["E2EUID"], WSUId: params["WSUID"], Instance: params["Instance"] } });
        }
        else if(params["WSUId"]!=null && params["WSUId"]!=""){
          this.router.navigate(['deepdive'], { queryParams: { E2EUId: params["E2EUId"], WSUId: params["WSUId"], Instance: params["Instance"] } });
        }
        else if(params["E2EUID"]!=null){
        this.router.navigate(['deepdive'], { queryParams: { E2EUId: params["E2EUID"], Instance: params["Instance"] } });
        }
        else{
          this.router.navigate(['deepdive'], { queryParams: { E2EUId: params["E2EUId"], Instance: params["Instance"] } });
        }
      }
    }
    else if (sessionStorage.getItem('redirectURL') != null && sessionStorage.getItem('redirectURL') != '' && sessionStorage.getItem('redirectURL') != undefined && sessionStorage.getItem('redirectURL').toLowerCase().includes('versionid') && !sessionStorage.getItem('redirectURL').toLowerCase().includes('e2euid')) {
      console.log("entered second block****")
      let x = sessionStorage.getItem('redirectURL')
      // localStorage.removeItem('ReturnURL');
      var params = {};
      var parser = document.createElement('a');
      parser.href = x;
      var vars = parser.search.substring(1).split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
      console.log("params --- ",params)
  }
  console.log("Router called")
      sessionStorage.setItem("VersionId", params["VersionId"]);
      this.router.navigate(['Ticket/Index'], { queryParams: { VersionId: params["VersionId"], DDName: params["DDName"] } }); 
  }
      }
      
      } else {
      //local debug
      console.log("msal=false")
      
      }
      this.route.queryParams.subscribe(params => {
        console.log("route.queryparams session- ",sessionStorage.getItem('redirectURL').includes('?'))
        console.log("route.queryparams object- ",Object.keys(params).length)
          if (Object.keys(params).length > 0 === window.location.href.includes('?')) {
            this.urlVersionId = this.iomservice.GetValueFromQueryParams(params, "VersionId")            
            if (this.urlVersionId != undefined && this.urlVersionId != "") {
              this.LoggedInUser = sessionStorage.getItem('userName');
              sessionStorage.setItem("VersionId", this.urlVersionId);
              this.bookmarkversionId = true;
            }
            else {
              this.bookmarkversionId = true;
            }
          }});

      let x = sessionStorage.getItem('redirectURL')       
      var params = {};
      var parser = document.createElement('a');
      parser.href = x;
      var vars = parser.search.substring(1).split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      sessionStorage.setItem("Instance", params["Instance"]);
      if(this.envData.Env == "SAAS_ManualUpload" && params["Instance"] == undefined){         
        sessionStorage.setItem("Instance", 'SAAS');
      }

    console.log("bookmarkversionId",this.bookmarkversionId)
    if (this.envData.AuthProvider == "local") {
      sessionStorage.setItem('userName', '');
      this.message = 'Loaded';
      // this.GetAccessDetails();
    }
    var userName = sessionStorage.getItem("userName");	
		if (userName == "null" || userName == "" || userName == "undefined" || userName == null || userName == undefined) {
			userName = "";
		}
    if (sessionStorage && userName != "") {
      this.initializeUserNotificationContent();
      console.log("Discalimer Called")
    }    
  }
  initInterval() {
    setInterval(() => {
      this.checkToken();
    }, this.envData.PAM_Token_ChkInterval);
  }

  isLoggedIn(): boolean {
    console.log("isLoggedIn menthod",this.msalService.instance.getActiveAccount())
    return this.msalService.instance.getActiveAccount() != null
  }
  checkToken() {
    if (sessionStorage.getItem("ExpirationDate") != null) {
      var expDate = sessionStorage.getItem('ExpirationDate');
      var dtArr = expDate.split('T');
      var date = dtArr[0].split('-');
      var temp = date[2] + '-' + date[1] + '-' + date[0];
      var tokenExpDate = new Date(temp + 'T' + dtArr[1]);
      var duration = 2;
      tokenExpDate.setMinutes(tokenExpDate.getMinutes() - duration);
      var dtNow = new Date();
      if (dtNow < tokenExpDate) {
      }
      else {
        this.iomservice.GetPAMTokenFromAPI().subscribe(
          data => {
            if (data != null) {
              sessionStorage.setItem('userName', data.user);
              sessionStorage.setItem('IOMToken', data.token);
              sessionStorage.setItem('ExpirationDate', data.expirationDate);
              this.iomservice.setPAMAuthentication(true);
            }

          });
      }
    }
  }
  login() {
    const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
    console.log("entered login function,isIE=",isIE)
    this.msalService.instance.loginRedirect();

  this.msalService.instance.handleRedirectPromise().then(res => {
  if (res != null && res.account != null) {
    console.log('User logged in sucessfully - '+ res.account );
  // console.log('id_token - ', res.idToken);
  this.msalService.instance.setActiveAccount(res.account);
  this.enterpriseId = res.account.username.split('@')[0];
  console.log('enterpriseid - '+ this.enterpriseId);
  let user = {
  username: this.enterpriseId,
  email: res.account.username
  }
  console.log("user",user)

  }
  })
    // if (!isIE) {

    //   this.msalService.loginRedirect();
    // } else {
    //   this.msalService.loginPopup();
    // }
  }
  initializeUserNotificationContent(): void {
    const content = {
      DataSourceUId: "00100000-0010-0000-0000-000000000000",
      TemplateUId: "00200000-0010-0000-0000-000000000000",
      ServiceUrl: "usernotification/UserNotification.json",
      ActiveLanguage: "en-US"//sessionStorage.getItem('Culture')
    }
    userNotification.init(content);
  }
  ngOnDestroy() {
    // this.broadcastService.getMSALSubject().next(1);
    if (this.successSubscription) {
      this.successSubscription.unsubscribe();
    }
  }
}
